import styled from "@emotion/styled";
import {
  GridColumn,
  Spacings,
  Divider,
  Emphasis,
  Caption,
  ConvertHTMLtoComponents,
} from "@polestar/component-warehouse-react";
import React from "react";

import parseMarkdownLinkToHtml from "../../data/parseMarkdownLinkToHtml/parseMarkdownLinkToHtml";

//  Value and label has to be the same value in table plugin column names (Case sensitive.) For type safety and consistency i decided to hardocode these keys.
interface Props {
  readonly value: string;
  readonly label: string;
}

const StyledGridColumn = styled(GridColumn)`
  :last-child {
    display: none;
  }
`;

const GridColumnValue = styled(GridColumn)`
  white-space: pre-line;
`;

const DescriptionListItem: React.FC<Props> = ({ value, label }) => {
  return (
    <>
      <GridColumn
        aria-label={label}
        as="dt"
        span={{
          mobile: 4,
          tablet: 8,
          desktop: 5,
          desktopWide: 5,
        }}
      >
        <Caption>{label}</Caption>
      </GridColumn>
      <GridColumnValue
        as="dd"
        span={{
          mobile: 4,
          tablet: 8,
          desktop: 7,
          desktopWide: 7,
        }}
      >
        <ConvertHTMLtoComponents
          overrideElementMap={{
            br() {
              return null;
            },
          }}
        >
          {parseMarkdownLinkToHtml(value)}
        </ConvertHTMLtoComponents>
      </GridColumnValue>
      <StyledGridColumn
        // See https://dequeuniversity.com/rules/axe/4.4/definition-list?application=axeAPI
        aria-hidden
        span={{ mobile: 4, tablet: 8, desktop: 12 }}
      >
        <Divider emphasis={Emphasis.low} spacing={Spacings.xxLarge} />
      </StyledGridColumn>
    </>
  );
};

export default DescriptionListItem;
